<template>
  <div id="category-page" v-if="category">
    <b-overlay :show="branchesNearbyLoading" rounded="sm" class="my-5">
      <template v-if="!branchesNearbyLoading">
        <HomePageSwitcher @setActiveTab="setActiveTab" />
        <div
          id="header"
          :style="{
            backgroundColor: category.background_color,
          }"
        >
          <div
            id="banner"
            :style="{
              backgroundImage: `url(${require('@/assets/images/waves.svg')})`,
            }"
          ></div>
          <b-container id="category-name" class="px-md-5">{{
            category.name
          }}</b-container>
        </div>
      </template>
      <b-container class="px-md-5"> 
        <template v-if="!location">
          <EnterLocation />
        </template>
        <template v-else>
          <template v-if="branchesNearby">
            <b-row class="py-4">
              <b-col class="h5">
                {{
                  `${branchesNearby.length} store${
                    branchesNearby.length > 1 ? "s" : ""
                  } near you`
                }}
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-row
                  class="position-relative"
                  v-if="branchesNearby && branchesNearby.length"
                >
                  <div class="tab-navigation">
                    <img
                      src="@/assets/images/chevron-left.png"
                      alt="Previous"
                      height="29"
                      width="29"
                      @click="scrollLeft"
                    />
                  </div>
                  <div id="tabs" ref="tabs" v-dragscroll>
                    <div
                      class="tab"
                      v-for="(branch, key) in branchesNearby"
                      :key="key"
                      :class="{
                        'active-tab': selectedBranchUuid === branch.uuid,
                      }"
                      :style="{
                        borderBottomColor:
                          webDesign && webDesign.design
                            ? webDesign.design.main_color
                            : null,
                      }"
                      @click="getProducts(branch.brand_uuid, branch.uuid, true)"
                    >
                      {{ branch.brand_name }} ({{ branch.name }})
                    </div>
                  </div>
                  <div class="tab-navigation">
                    <img
                      src="@/assets/images/chevron-right.png"
                      alt="Next"
                      height="29"
                      width="29"
                      @click="scrollRight"
                    />
                  </div>
                </b-row>
                <template>
                  <template v-if="products.length">
                    <b-row class="my-5">
                      <b-col
                        md="6"
                        lg="4"
                        class="mb-3"
                        v-for="(product, key) in products"
                        :key="key"
                      >
                        <b-card
                          @click="
                            $router.push({
                              name: 'Store',
                              params: {
                                id: `${selectedBranchUuid}&${selectedBrandUuid}`,
                                productUuid: product.uuid,
                              },
                            })
                          "
                        >
                          <b-container>
                            <b-row no-gutters>
                              <b-col cols="8">
                                <div class="product-contents">
                                  <div>
                                    <div class="product-name">
                                      {{ product.name | truncate(15) }}
                                    </div>
                                  </div>
                                  <template
                                    v-if="
                                        product.sale_inventory && 
                                        product.sale_inventory.on_sale &&
                                        $moment().isBetween(
                                          product.sale_inventory.on_sale_from, 
                                          product.sale_inventory.on_sale_to
                                        ) 
                                    "
                                  >
                                    <div>
                                      <span class="original-price">
                                        &#8369;
                                        {{ product.sale_inventory.regular_price }}
                                      </span>
                                      <span
                                        class="sale-price ml-2"
                                        :style="{
                                          color:
                                            webDesign.design.main_color +
                                            '!important',
                                        }"
                                      >
                                        &#8369;
                                        {{
                                          product.sale_inventory.sale_price
                                            .toFixed(2)
                                            .toLocaleString()
                                        }}
                                      </span>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <span
                                      class="sale-price"
                                      :style="{
                                        color:
                                          webDesign.design.main_color +
                                          '!important',
                                      }"
                                    >
                                      &#8369; {{ product.price }}
                                    </span>
                                  </template>
                                </div>
                              </b-col>
                              <b-col
                                v-if="product.images && product.images.length"
                              >
                                <b-img
                                  :src="product.images[0].image_name"
                                  alt="Product"
                                  class="product-image"
                                />
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-card>
                      </b-col>
                    </b-row>
                    <mugen-scroll
                      :handler="loadMoreProducts"
                      :should-handle="!productsLoading"
                    />
                  </template>
                  <template v-if="!products.length && !productsLoading">
                    <b-row class="py-5">
                      <b-col class="text-center">
                        <div
                          class="h3"
                          :class="[
                            { 'text-primary': !webDesign || !webDesign.design },
                          ]"
                          :style="{
                            color:
                              webDesign && webDesign.design
                                ? webDesign.design.main_color
                                : null,
                          }"
                        >
                          Sorry, no products found for this category.
                        </div>
                      </b-col>
                    </b-row>
                  </template>
                </template>
                <template v-if="productsLoading">
                  <b-row class="py-5">
                    <b-col class="text-center">
                      <div
                        class="h3"
                        :class="[
                          { 'text-primary': !webDesign || !webDesign.design },
                        ]"
                        :style="{
                          color:
                            webDesign && webDesign.design
                              ? webDesign.design.main_color
                              : null,
                        }"
                      >
                        Loading...
                      </div>
                    </b-col>
                  </b-row>
                </template>
              </b-col>
            </b-row>
          </template>
        </template>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import HomePageSwitcher from "@/components/layout/HomePageSwitcher";
import EnterLocation from "@/components/store/EnterLocation";
import { dragscroll } from "vue-dragscroll";
import { mapState, mapGetters } from "vuex";
import MugenScroll from "vue-mugen-scroll";

export default {
  data() {
    return {
      products: [],
      scrollValue: 0,
      selectedBrandUuid: null,
      selectedBranchUuid: null,
      page: 1,
      dateToday: this.$moment()
    };
  },
  props: ["uuid", "id"],
  components: {
    HomePageSwitcher,
    EnterLocation,
    MugenScroll,
  },
  directives: {
    dragscroll,
  },
  computed: {
    ...mapState("merchant", ["customerPortalToken"]),
    ...mapState("design", ["homeWebLayout"]),
    ...mapState("customer", ["location"]),
    ...mapState("branch", ["coordinates", "branchesNearby"]),
    ...mapState("branch", {
      branchesNearbyLoading: (state) => state.loading,
    }),
    ...mapState("auth", ["token"]),
    ...mapState("estore", ["productsByCategory", "webDesign"]),
    ...mapState("estore", {
      productsLoading: (state) => state.loading,
      nextPage: (state) => state.nextPage,
    }),
    ...mapGetters("auth", ["isAuthenticated"]),
    category() {
      return this.homeWebLayout && this.homeWebLayout.categories
        ? JSON.parse(this.homeWebLayout.categories).find(
            (category) => category.id === Number(this.id)
          )
        : null;
    },
  },
  filters: {
    truncate(value, length) {
      return value.length > length ? `${value.substring(0, length)}...` : value;
    },
  },
  methods: {
    scrollLeft() {
      this.$refs.tabs.scrollTo({
        top: 0,
        left: Math.min((this.scrollValue -= 500), 0),
        behavior: "smooth",
      });
    },
    scrollRight() {
      this.$refs.tabs.scrollTo({
        top: 0,
        left: Math.max((this.scrollValue += 500), this.$refs.tabs.clientWidth),
        behavior: "smooth",
      });
    },
    async getNearbyStores(latitude, longitude) {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          latitude,
          longitude,
          filters: { product_category_uuid: this.uuid },
        },
      };
      if (this.isAuthenticated) {
        request.header["Authorization"] = this.token;
        await this.$store.dispatch("branch/getBranchesNearby", request);
      } else
        await this.$store.dispatch("branch/getBranchesNearbyPublic", request);
    },
    async getProducts(brandUuid, branchUuid, initializeData = false) {
      this.selectedBrandUuid = brandUuid;
      this.selectedBranchUuid = branchUuid;

      if (initializeData) {
        this.products = [];
        this.page = 1;
      }

      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          brand_uuid: brandUuid,
          branch_uuid: branchUuid,
        },
        categoryId: this.id,
        page: this.page,
      };
      if (this.isAuthenticated) {
        request.header["Authorization"] = this.token;
        await this.$store.dispatch("estore/getProductsByCategory", request);
      } else {
        await this.$store.dispatch(
          "estore/getPublicProductsByCategory",
          request
        );
      }

      this.products = [...this.products, ...this.productsByCategory];
      this.formatProducts();
    },
    async loadMoreProducts() {
      if (!this.nextPage) return;

      this.page++;
      await this.getProducts(this.selectedBrandUuid, this.selectedBranchUuid);
      // this.products = [...this.products, ...this.productsByCategory];
      this.formatProducts();
    },
    setActiveTab() {
      this.$router.push({ name: "Home" });
    },
    async getStoresAndProducts(latitude, longitude) {
      this.$store.commit("estore/setProductsByCategory", []);

      await this.getNearbyStores(latitude, longitude);

      if (this.branchesNearby && this.branchesNearby.length)
        await this.getProducts(
          this.branchesNearby[0].brand_uuid,
          this.branchesNearby[0].uuid
        );
    },
    formatProducts() {
      this.products.forEach((_, index) => {
        this.products[index].sale_inventory = this.products[index].inventory.find(
          (inventory) =>
            inventory.sale_price == this.products[index].price.replace(",", "")
        );
      });
    },
  },
  watch: {
    coordinates(value) {
      if (value) 
        this.getStoresAndProducts(value.lat, value.long);
    },
  },
  async created() {
    this.$store.commit("estore/setProductsByCategory", []);

    if (!Object.keys(this.homeWebLayout).length)
      await this.$store.dispatch("design/getHomeWebLayout", {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
      });

    this.getStoresAndProducts(this.coordinates.lat, this.coordinates.long);
  },
};
</script>

<style scoped lang="scss">
#category-page {
  min-height: 100vh;
  #header {
    height: 35vh;
    position: relative;
    display: flex;
    align-items: center;
  }
  #banner {
    width: 100%;
    height: 100%;
    filter: opacity(0.5);
    position: absolute;
    object-fit: cover;
  }
  #category-name {
    font-size: 40px;
    color: #ffffff;
    z-index: 1;
    @extend .mainFontBold;
  }
  #tabs {
    position: relative;
    border-top: 1px solid #d8dcde;
    border-bottom: 1px solid #d8dcde;
    display: flex;
    flex: 1;
    flex-wrap: nowrap;
    overflow: auto;
    -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
    scrollbar-width: none; /* Hide scrollbar for Firefox */
    &::-webkit-scrollbar {
      display: none; /* Hide scrollbar for Chrome */
    }
  }
  .tab {
    flex-shrink: 0;
    flex-grow: 1;
    padding: 15px;
    cursor: default;
  }
  .tab-navigation {
    border-top: 1px solid #d8dcde;
    border-bottom: 1px solid #d8dcde;
    padding: 15px 5px;
    cursor: pointer;
  }
  .active-tab {
    border-bottom: 6px solid #ff8a00;
  }
  .product-contents {
    height: 125px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .product-name {
    font-size: 18px;
    @extend .mainFontBold;
  }
  .product-image {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 5px;
  }
  .original-price {
    font-size: 14px !important;
    text-decoration-line: line-through;
    color: #87929d !important;
  }
  .sale-price {
    font-style: normal !important;
    font-size: 18px !important;
    color: #ff8a00 !important;
    @extend .mainFontBold;
  }
}
</style>
